import { render, staticRenderFns } from "./DraggableEmpresasCampanha.vue?vue&type=template&id=13fb2d76&scoped=true&"
import script from "./DraggableEmpresasCampanha.vue?vue&type=script&lang=js&"
export * from "./DraggableEmpresasCampanha.vue?vue&type=script&lang=js&"
import style0 from "./DraggableEmpresasCampanha.vue?vue&type=style&index=0&id=13fb2d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb2d76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VDivider,VIcon,VRow,VTooltip})
